/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet } from 'react-native';
import { RadioButton } from 'react-native-paper';
import QText from './QText';
import { useThemedStyles } from '../hooks';
import { useTranslation } from 'react-i18next';

const RadioGroup = ({
  options,
  value,
  onValueChange,
  style,
  itemStyle,
  textStyle,
  error,
  translateLabels = true,
}) => {
  const styles = useThemedStyles(createStyles);
  const { t } = useTranslation();

  const getLabel = (option) => {
    if (typeof option === 'string') {
      return translateLabels ? t(option) : option;
    }
    return translateLabels ? t(option.label) : option.label;
  };

  const getValue = (option) => {
    if (typeof option === 'string') {
      return option;
    }
    return option.value;
  };

  return (
    <View style={[styles.container, style]}>
      {options.map((option, index) => {
        const optionValue = getValue(option);
        const optionLabel = getLabel(option);

        return (
          <View key={index} style={[styles.itemContainer, itemStyle]}>
            <RadioButton
              value={optionValue}
              status={value === optionValue ? 'checked' : 'unchecked'}
              onPress={() => onValueChange(optionValue)}
            />
            <QText style={[styles.label, textStyle]}>{optionLabel}</QText>
          </View>
        );
      })}
      {error && (
        <QText style={styles.errorText}>
          {translateLabels ? t(error) : error}
        </QText>
      )}
    </View>
  );
};

RadioGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
      }),
    ])
  ).isRequired,
  value: PropTypes.any,
  onValueChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  itemStyle: PropTypes.object,
  textStyle: PropTypes.object,
  error: PropTypes.string,
  translateLabels: PropTypes.bool,
};

RadioGroup.defaultProps = {
  value: null,
  style: {},
  itemStyle: {},
  textStyle: {},
  error: '',
  translateLabels: true,
};

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      marginVertical: 8,
    },
    itemContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginVertical: 4,
    },
    label: {
      color: theme.colors.secondaryText,
      fontSize: 16,
      marginLeft: 8,
      flex: 1,
    },
    errorText: {
      fontSize: 12,
      color: theme.colors.errorColor,
      marginTop: 4,
      marginLeft: 12,
    },
  });

export default RadioGroup;
